import React from "react";
import FieldRow from "./FieldRow";

export default function ProductsList({ products = [], onCopy }) {
  if (!products.length) {
    return (
      <p style={{ fontSize: "0.8rem", color: "#94a3b8" }}>
        Товаров нет
      </p>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
      {products.map((p) => (
        <div
          key={p.id}
          style={{
            borderRadius: "0.5rem",
            border: "1px solid #e2e8f0",
            padding: "0.4rem 0.5rem",
            background: "#f8fafc",
          }}
        >
          <FieldRow label="Название" value={p.product_name} onCopy={onCopy} />
          <FieldRow label="Номер" value={p.product_number} onCopy={onCopy} />
          <FieldRow label="Кол-во (факт)" value={p.actual_quantity} onCopy={onCopy} />
          <FieldRow label="GTIN" value={p.gtin} onCopy={onCopy} />
          {Array.isArray(p.marks) && p.marks.length > 0 && (
            <div style={{ marginTop: "0.25rem" }}>
              <span
                style={{
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  display: "block",
                  marginBottom: "0.1rem",
                }}
              >
                Маркировки (кликабельны):
              </span>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.25rem",
                }}
              >
                {p.marks.map((m, idx) => (
                  <span
                    key={idx}
                    onClick={() => onCopy(m)}
                    style={{
                      fontSize: "0.7rem",
                      borderRadius: "999px",
                      border: "1px solid #cbd5f5",
                      padding: "0.1rem 0.4rem",
                      cursor: "pointer",
                      background: "#e0ebff",
                    }}
                  >
                    {m}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
